@if (publicnode | async; as item) {
  <div id="publicpage">
    <div class="bannerimg">
      <img class="publicbanner" alt="Public-Banner" [src]="getImage(item.media)">
      <div class="publicheadertext">
        <div class="publicheader_contianer">
          <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
          <div class="publicheader">{{item.headLine1}}</div>
        </div>
      </div>
    </div>
    <div class="publiccontainer1">
      <div class="publicsubtext" [innerHTML]="item.textPageContent1"></div>
    </div>
    <div class="publiccontainer2">
      <div class="gbtext" [innerHTML]="item.textPageContent2"></div>
      <div class="gbflex">
        <div class="gbblacktext" [innerHTML]="item.header2"></div>
        <div class="gbredtext">
          <a data-toggle="modal" (click)="openModal('aujemflu')" [innerHTML]="item.Commonlintext"></a>
        </div>
      </div>
      <div class="gbflex">
        <div class="gbblacktext" [innerHTML]="item.TextPage2"></div>
        <div class="gbredtext">
          <a data-toggle="modal" (click)="openModal('ativ')" [innerHTML]="item.Commonlintext"></a>
        </div>
      </div>
      <div class="gbflex">
        <div class="gbblacktext" [innerHTML]="item.TextPage3"></div>
        <div class="gbredtext">
          <a data-toggle="modal" (click)="openModal('tivc')" [innerHTML]="item.Commonlintext"></a>

        </div>
      </div>
    </div>
    <div class="publiccontainer3">
      <!-- <div class="reporttext">{{item.header2}}</div> -->
      <div class="reportsubtext1 textbtn1" [innerHTML]="item.PageSubText"></div>
      <div class="reportsubtext textbtn">
        <span [innerHTML]="item.PageBottomcontent1"></span>
        <a class="mhralink externallinkpopupUK" data-toggle="modal" (click)="openModal('mhr')">&nbsp;<span [innerHTML]="item.linkText"></span>.<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 9.33333V4H14.6667M20 4L10.2222 13.7778M17.3333 12.8889V18.2222C17.3333 18.6937 17.146 19.1459 16.8126 19.4793C16.4792 19.8127 16.0271 20 15.5556 20H5.77778C5.30628 20 4.8541 19.8127 4.5207 19.4793C4.1873 19.1459 4 18.6937 4 18.2222V8.44444C4 7.97295 4.1873 7.52076 4.5207 7.18737C4.8541 6.85397 5.30628 6.66667 5.77778 6.66667H11.1111" stroke="#2A3237" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
    <div class="commonleaving_abandonedPop modal  fade in show" role="dialog" data-bs-backdrop="static"
      data-keyboard="false" id="commonleaving_abandonedPop" tabindex="-1">
      <div class="modal-body knowledgeHub_abandonedPopContent">
        <div class="knowledgeHub_abandonedPopHeader">
          <div class="knowledgeHub_abandonedPopTitle">{{item.PopupData.headline}}</div>
          <div class="knowledgeHub_abandonedPopClose" (click)="closeModal()">X</div>
          <div class="clearboth"></div>
        </div>
        <div class="knowledgeHub_abandonedPopText">
          <p [innerHTML]="item.PopupData.message1"></p>
          <p [innerHTML]="item.PopupData.message2"></p>
        </div>
        <div class="knowledgeHub_abandonedPopBtns">
          <ng-container *ngIf="link=='aujemflu'"> 
            <a (click)="closeModal()"
              class="commonleave_popContBtn knowledgeHub_abandonedPopBtn"
              [href]="item.urlLink"
              target="_blank">
              {{item.PopupData.label1}}
            </a>
          </ng-container>
          <ng-container *ngIf="link=='ativ'"> 
            <a (click)="closeModal()"
              class="commonleave_popContBtn knowledgeHub_abandonedPopBtn"
              [href]="item.link1"
              target="_blank">
              {{item.PopupData.label1}}
            </a>
          </ng-container>

          <ng-container *ngIf="link=='tivc'"> 
            <a (click)="closeModal()"
              class="commonleave_popContBtn knowledgeHub_abandonedPopBtn"
              [href]="item.link2"
              target="_blank">
              {{item.PopupData.label1}}
            </a>
          </ng-container>

          <ng-container *ngIf="link=='mhr'"> 
            <a (click)="closeModal()"
              class="commonleave_popContBtn knowledgeHub_abandonedPopBtn"
              [href]="item.PopupData.link"
              target="_blank">
              {{item.PopupData.label1}}
            </a>
          </ng-container>

          <button class="knowledgeHub_abandonedPopBtn knowledgeHub_popCanceltBtn"
            (click)="closeModal()">
            {{item.PopupData.label2}}
          </button>

        </div>
        <div class="knowledgedocnumberUk">{{item.PopupData.jobBagCode}}</div>
      </div>
    </div>
  </div>
}
